import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Route, Routes } from "react-router-dom";

import NavigationBar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Home from "./components/Home";
import ServiceDetail from "./pages/ServiceDetail";

function App() {
  return (
    <>
      <NavigationBar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;